module.exports = __webpack_public_path__ + "static/media/32.8de978ba.mp3";